<template>
    <div v-if="response">
        <component v-if="response.status === 200" :is="getComponentName()" :data="data"></component>
        <div v-else class="col-lg-8">
            <div class="tile">
                Ошибка {{ response.status }}
            </div>
        </div>
    </div>
</template>

<script>
import { getConfig } from '@/auth'
import ShowV1 from '@/components/public-hearing/ShowV1.vue'
import ShowV2_1 from '@/components/public-hearing/ShowV2_1.vue'
import ShowV2_2 from '@/components/public-hearing/ShowV2_2.vue'
import ShowV3 from '@/components/public-hearing/ShowV3.vue'
import ShowV4 from '@/components/public-hearing/ShowV4.vue';
import ShowV5 from '@/components/public-hearing/ShowV5.vue';
import ShowV6 from '@/components/public-hearing/ShowV6.vue';
import ShowV7 from '@/components/public-hearing/ShowV7.vue';
import ShowV8 from '@/components/public-hearing/ShowV8.vue';


export default {
    components: {
        ShowV1,
        ShowV2_1,
        ShowV2_2,
        ShowV3,
        ShowV4,
        ShowV5,
        ShowV6,
        ShowV7,
        ShowV8,
    },
    data() {
        return {
            data: {},
            componentNames: {
                'v1': 'ShowV1',
                'v2.1': 'ShowV2_1',
                'v2.2': 'ShowV2_2',
                'v3': 'ShowV3',
                'v4': 'ShowV4',
                'v5': 'ShowV5',
                'v6': 'ShowV6',
                'v7': 'ShowV7',
                'v8': 'ShowV8',
            },
            defaultComponentName: 'ShowV1',
            response: null,
        }
    },
    async created() {
        const id = this.$route.params.id
        const url = getConfig().apiURL + `/public-hearing/ph-projects/${id}`
        this.response = await fetch(url)

        if (this.response.status === 200) {
            this.data = await this.response.json()
        }
    },
    methods: {
        getComponentName: function () {
            return this.componentNames[this.data?.template_version] ?? this.defaultComponentName
        }
    }
}
</script>